import { createSlice } from "@reduxjs/toolkit";
import VwKullaniciDTO from "src/models/Base/Auth/VwKullaniciDTO";
import HbsUcretTarifetanimDTO from "src/models/Settings/Generals/HbsUcretTarifeTanimDTO";
import VwGnlKullaniciTarifeIptalDTO from "src/models/Settings/Generals/VwGnlKullaniciTarifeIptalDTO";
import VwUcrettarifeDTO from "src/models/Settings/Generals/VwUcrettarifeDTO";
import MapReducerPayloads from "src/models/store/MapReducerPayloads";
import { kullaniciTarifeApi } from "src/services/geneltanimlar/KullanicTarifeApi";

export class UcretTarifeTanimAramaKriterleri {
    aciklama?: string = "";
}

interface IKullaniciTarife {
    kullaniciTanimActiveRow?: VwKullaniciDTO;
    ucretTarifeTanimActiveRow?: HbsUcretTarifetanimDTO;
    kullaniciTarifeIptalList?: Array<VwGnlKullaniciTarifeIptalDTO>;
    fetchKullaniciTarife: boolean;
};

export const KullaniciTarifeSlice = createSlice<IKullaniciTarife, MapReducerPayloads<IKullaniciTarife, {
    setKullaniciTanimActiveRow?: VwKullaniciDTO;
    setUcretTarifeTanimActiveRow?: HbsUcretTarifetanimDTO;
    setKullaniciTarifeIptalList?: Array<VwGnlKullaniciTarifeIptalDTO>
    setFetchKullaniciTarife: boolean
}>>({
    name: "UcretTarifeTanimState",
    initialState: {
        kullaniciTanimActiveRow: new VwKullaniciDTO(),
        ucretTarifeTanimActiveRow: new HbsUcretTarifetanimDTO(),
        kullaniciTarifeIptalList: [],
        fetchKullaniciTarife: false
    },
    reducers: {
        setKullaniciTanimActiveRow: (state, action) => {
            state.kullaniciTanimActiveRow = action.payload
        },
        setUcretTarifeTanimActiveRow: (state, action) => {
            state.ucretTarifeTanimActiveRow = action.payload
        },
        setKullaniciTarifeIptalList: (state, action) => {
            state.kullaniciTarifeIptalList = action.payload
        },
        setFetchKullaniciTarife: (state, action) => {
            state.fetchKullaniciTarife = action.payload
        }
    }
});